import { Component } from '@angular/core';

@Component({
    selector: 'ms-speed-reading-footer',
    templateUrl: './speed-reading-footer.component.html',
    styleUrls: ['./speed-reading-footer.component.scss'],
    standalone: false
})
export class SpeedReadingFooterComponent {

}
